import React from 'react';

import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';
import IconCheckBox from '@material-ui/icons/CheckBox';
import IconCheckBoxBlank from '@material-ui/icons/CheckBoxOutlineBlank';

export interface CheckboxProps extends MuiCheckboxProps {
  size?: 'small';
}

export const Checkbox: React.FC<CheckboxProps> = ({ size, ...rest }) => (
  <MuiCheckbox
    icon={size === 'small' ? <IconCheckBoxBlank fontSize="small" /> : undefined}
    checkedIcon={size === 'small' ? <IconCheckBox fontSize="small" /> : undefined}
    {...rest}
  />
);
